export function isFdlAdminEnabled() {
  return typeof __FDL_ADMIN_ENABLED__ !== 'undefined' && __FDL_ADMIN_ENABLED__ === true;
}

export function isMsiAdminEnabled() {
  return typeof __MSI_ADMIN_ENABLED__ !== 'undefined' && __MSI_ADMIN_ENABLED__ === true;
}
